import { useState } from "react";
import { motion, useMotionValueEvent, useTransform } from "framer-motion";

const LINKS = [
  { label: "About Us", target: "#about", testId: "nav-link-about" },
  { label: "Capabilities", target: "#capabilities", testId: "nav-link-capabilities" },
  { label: "Projects", target: "#projects", testId: "nav-link-projects" },
  { label: "Contacts", target: "#contact", testId: "nav-link-contacts" },
];

export default function Navigation({ scrollYProgress, onNavigate }) {
  const [deep, setDeep] = useState(false);
  useMotionValueEvent(scrollYProgress, "change", (v) => setDeep(v > 0.1));
  const depthText = useTransform(
    scrollYProgress,
    (v) => `${Math.round(v * 3000)}m`
  );

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.9 }}
      data-testid="main-nav"
      className={`fixed inset-x-0 top-0 z-40 border-b backdrop-blur-md transition-[background-color,border-color,color] duration-700 ${
        deep
          ? "border-white/10 bg-[#020B14]/35 text-[#F8FAFC]"
          : "border-[#02252e]/10 bg-[#26c6d3]/10 text-[#02252e]"
      }`}
    >
      <nav className="flex items-center justify-between px-6 py-4 md:px-12">
        <button
          type="button"
          onClick={() => onNavigate(0)}
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <img
            src="/okeanos-mark.png"
            alt="Okeanos wave mark"
            className="h-8 w-auto md:h-9"
            data-testid="nav-logo-image"
          />
          <span className="font-brand text-xl leading-none tracking-wide">
            Oκεαηοs
          </span>
        </button>

        <div className="hidden items-center gap-9 lg:flex">
          {LINKS.map((link) => (
            <button
              key={link.testId}
              type="button"
              onClick={() => onNavigate(link.target)}
              data-testid={link.testId}
              className="group relative font-mono text-[10px] uppercase tracking-[0.3em] opacity-80 transition-opacity duration-300 hover:opacity-100"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-current transition-transform duration-300 group-hover:scale-x-100" />
            </button>
          ))}
        </div>

        <div className="flex items-center gap-5">
          <motion.span
            className="hidden font-mono text-[10px] tracking-[0.2em] opacity-70 sm:block"
            data-testid="nav-depth-readout"
          >
            {depthText}
          </motion.span>
          <button
            type="button"
            onClick={() => onNavigate("#contact")}
            data-testid="nav-contact-cta"
            className={`rounded-full px-5 py-2 font-mono text-[10px] uppercase tracking-[0.25em] transition-[transform,background-color,color] duration-300 hover:scale-105 active:scale-95 ${
              deep
                ? "bg-[#f58220] text-[#1a0d00]"
                : "bg-[#02252e] text-[#F8FAFC]"
            }`}
          >
            Dive In
          </button>
        </div>
      </nav>
    </motion.header>
  );
}
